module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "share"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "introduce",
    on: {
      "click": function($event) {
        return _vm.showCoverAction({
          show: true,
          type: 1
        })
      }
    }
  }, [_vm._v("\n    活动介绍\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "mid"
  }, [_c('div', {
    staticClass: "mid_div"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "mid_right"
  }, _vm._l((_vm.recordList), function(item, index) {
    return _c('li', {
      key: item.chaiId
    }, [(index == 0) ? _c('div', [_c('div', [_c('span', {
      staticStyle: {
        "margin-right": "0.133rem"
      }
    }, [_vm._v("好友")]), _c('img', {
      attrs: {
        "src": item.headPhoto,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.nickName))])]), _vm._v(" "), _c('p', [_c('span', {
      staticClass: "s1"
    }, [_vm._v("答题得红包")]), _c('span', {
      staticClass: "r"
    }, [_vm._v("￥" + _vm._s(item.redPack) + "元")])])]) : (item.nickName && index > 0) ? _c('div', [_c('div', [_c('img', {
      attrs: {
        "src": item.headPhoto,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.nickName))])]), _vm._v(" "), _c('p', [_c('span', {
      staticClass: "s1"
    }, [_vm._v("喜得红包")]), _c('span', {
      staticClass: "r"
    }, [_vm._v("￥" + _vm._s(item.redPack) + "元")])])]) : _c('x-button', {
      staticClass: "send_bt",
      nativeOn: {
        "click": function($event) {
          return _vm.ATM(item, index)
        }
      }
    }, [_vm._v("赶紧拆")])], 1)
  }), 0)])]), _vm._v(" "), _c('p', {
    staticClass: "has_not_p"
  }, [_vm._v("\n    " + _vm._s(!_vm.hasMore ? "红包已开完，快去寻找下一个吧" : "") + "\n  ")]), _vm._v(" "), _c('x-button', {
    staticClass: "go_bt",
    nativeOn: {
      "click": function($event) {
        return _vm.toHome.apply(null, arguments)
      }
    }
  }, [_vm._v("答题得红包")]), _vm._v(" "), _c('guide-cover', {
    attrs: {
      "money": _vm.getMoney
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [_c('div', [_c('p', [_vm._v("连对四题，即可凑齐拼图拆现金红包")]), _vm._v(" "), _c('p', [_vm._v("更有机会获得友情红包，可转赠好友")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "mid_left"
  }, [_c('li', [_c('img', {
    staticClass: "f",
    attrs: {
      "src": "http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E5%88%86%E4%BA%AB%E9%A1%B5-%E5%A5%BD%E5%8F%8B%E7%BA%A2%E5%8C%85@2x.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E5%88%86%E4%BA%AB%E9%A1%B5-%E7%BA%A2%E5%8C%85@2x.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E5%88%86%E4%BA%AB%E9%A1%B5-%E7%BA%A2%E5%8C%85@2x.png",
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-2afba040"}!./~/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./~/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/page/Share/index.vue
// module id = 233
// module chunks = 1